import IconBasic from "../assets/images/svg-icons/direct/icon-basic.svg";
import IconPlus from "../assets/images/svg-icons/direct/icon-plus.svg";
import polyglot from "./polyglot";

export const ID_OFFSET = 103_286;
export const JOB_ID_OFFSET = 51_327;

export const IS_PROD = process.env.NODE_ENV === "production" || process.env.NODE_ENV === "prod";

export const IS_STAGING = window.location.hostname.includes("yooplajob");

const getAppId = (ids) => {
  if (IS_PROD && !IS_STAGING) {
    return ids.PROD;
  }
  if (IS_STAGING) {
    return ids.STAGING;
  }
  return ids.DEV;
};

const getFacebookAppId = () => {
  const ids = {
    PROD: { id: "394601603934679", secret: "24091876e82cf58b0417cba1e4331e84" },
    STAGING: {
      id: "345646435534824",
      secret: "f42a7ef809586efffd9609030a40d446",
    },
    DEV: { id: "528165397204720", secret: "a579963f5d7b352fcc0072897587e34a" },
  };
  return getAppId(ids);
};

const getGoogleAppId = () => {
  const ids = {
    PROD: {
      id: "351545058608-dsftsq0jom0nidg3crj1jt46ugdo7pmo.apps.googleusercontent.com",
    },
    STAGING: {
      id: "69051606776-rlc7lfrtvv6lufmtdf51cn52db90i34a.apps.googleusercontent.com",
    },
    DEV: {
      id: "69051606776-rlc7lfrtvv6lufmtdf51cn52db90i34a.apps.googleusercontent.com",
    },
  };
  return getAppId(ids);
};

const getAppleAppId = () => {
  const ids = {
    PROD: {
      id: "prod.yoojo.com",
    },
    STAGING: {
      id: "dev.yoojo.com",
    },
    DEV: {
      id: "dev.yoojo.com",
    },
  };
  return getAppId(ids);
};

export const FACEBOOK_APP_ID = getFacebookAppId().id;
export const FACEBOOK_APP_SECRET = getFacebookAppId().secret;
export const GOOGLE_CLIENT_ID = getGoogleAppId().id;
export const APPLE_SERVICE_ID = getAppleAppId().id;

export const MAX_FIRST_NAME_LENGTH = 250;
export const MAX_LAST_NAME_LENGTH = 250;

export const PASSWORD_MINIMAL_LENGTH = 8;

export const WINDOW_WIDTH = window.innerWidth;

export const BREAKPOINTS = { xs: 0, sm: 576, md: 768, lg: 992, xl: 1200 };

export const YPJ = {
  YPJ_END_POINT: "http://localhost:3000",
};

export const YOOJO_COVER_PRICE = 250;
export const YOOJO_EXTENDED_COVER_PRICE = 1500;

export const JOB_COMMENT_MAX_LENGTH = 1000;

export const CESU_SCAN_RANGE = 3;

export const VISA_MASTERCARD = "visa_mastercard";
export const PAYPAL = "paypal";
export const MAESTRO = "maestro";
export const AMEX = "amex";
export const IBAN = "iban";

export const DIRECT_PLANS = {
  direct_basic: {
    title: "Basic",
    price: 9.9,
    artwork: IconBasic,
    advantages: [
      { title: "Paie de votre prestataire automatisée" },
      { title: "Fiche de paie automatisée" },
      { title: "Déclaratif automatisé (optionnel)" },
      { title: "Contrat de travail inclus (optionnel)" },
      { title: "Assistance téléphonique gratuite" },
      {
        title: "5% de remise sur les services ponctuels",
        subtitle: "Réparation, aménagement, garde, rangement, et d’autres ...",
      },
    ],
  },
  direct_plus: {
    title: "Plus",
    price: 14.9,
    artwork: IconPlus,
    advantages: [
      { title: "Paie de votre prestataire automatisée" },
      { title: "Fiche de paie automatisée" },
      { title: "Déclaratif automatisé (optionnel)" },
      { title: "Contrat de travail inclus (optionnel)" },
      { title: "Assistance téléphonique gratuite" },
      {
        title: "10% de remise sur les services ponctuels",
        subtitle: "Réparation, aménagement, garde, rangement, et d’autres ...",
      },
      {
        title: "Assurance incluse",
        subtitle: "Nous prenons en charge la casse et les accidents",
      },
      {
        title: "Remplacement de votre prestataire en cas d’imprévu",
        subtitle: "Nous trouvons un autre prestataire en cas d’imprévu ou de départ",
      },
    ],
  },
};

export const EXEMPTIONS = [
  { label: "Vous ou votre conjoint avez +70 ans", value: 0 },
  {
    label: "Vous bénéficiez de l’Allocation personnalisée d’autonomie (APA)",
    value: 1,
  },
  {
    label: "Vous bénéficiez de la Prestation de compensation du handicap (PCH ou ACTP)",
    value: 2,
  },
  { label: "Vous êtes titulaire d’une carte d’invalidité à 80 %", value: 3 },
  { label: "Vous bénéficiez de la Majoration pour tierce personne", value: 4 },
  {
    label: "Vous bénéficiez du complément de l’allocation d’éducation enfant handicapé (AEEH)",
    value: 5,
  },
];

export const MANGOPAY = {
  MANGOPAY_END_POINT: "/mangopay_cards",
};
export const USER_SEX = {
  1: polyglot.t("common.male"),
  2: polyglot.t("common.female"),
};
export const IS_DEV =
  !process.env.NODE_ENV ||
  process.env.NODE_ENV === "development" ||
  process.env.NODE_ENV === "test";

export const MANGOPAY_CLIENT_ID = IS_PROD && !IS_STAGING ? "hwvi6nr8k4vf" : "xvv7xyogrj1s";

export const GOOGLE_PAY_MERCHAND_ID = IS_PROD && !IS_STAGING ? "BCR2DN4TZ3C7HSZZ" : "TEST";

export const DASHBOARD_SMALL_CONTAINER = 550;
export const BRAND_NAME = "Yoojo";
export const CHAT_THUMBNAILS_KIND = { jobs: "jobs", tickets: "tickets" };
export const MAX_JOB_PHOTOS = 3;
export const GET_RATE_URL = (id) => `offers/${id}/rates/new`;

export const DEFAULT_CATEGORY_NB_HOURS = 2;

export const INSTANT_GO_NEXT_DELAY = 100;

export const PREFERED_COUNTRIES = ["FR", "CH", "BE", "LU", "NL", "UK", "IE", "ES", "PT", "IT"];

export const JOB_MIN_HOUR = 7;
export const JOB_MAX_HOUR = 21;

export const NEW_JOBBER_CREDIT = 5;

export const JOBBER_SEARCH_DISTANCE_MIN = 1;
export const JOBBER_SEARCH_DISTANCE_MAX = 50;
export const JOBBER_SEARCH_PRICE_MIN = 9;
export const JOBBER_SEARCH_PRICE_MAX = 50;

export const JOBBER_SEARCH_ROLES = [
  "handyman",
  "handyman2",
  "painter",
  "plumber",
  "electrician",
  "locksmith",
  "gardener",
  "mover",
  "maid",
  "domestic_help",
  "cleaner",
  "baby_sitter",
  "nanny",
  "maternity_attendant",
  "pet_sitter",
  "dog_sitter",
  "cat_sitter",
  "computer_scientist",
  "concierge",
  "life_auxiliary",
  "professor",
];

export const NON_ELIGIBLE_DIPLOMA_SKILLS = ["baby_sitting"];
export const ELIGIBLE_SMOKER_AND_DRIVER_SKILLS = ["baby_sitting"];

export const BABY_SITTING_HAVE_DIPLOMA_SUBTITLE = [
  "bafa",
  "cap",
  "assp",
  "deap",
  "deeje",
  "meef",
  "dep",
  "cs",
];

export const MEMBERSHIP_STATES = {
  SUSPENDED: "suspended",
  CANCELED: "canceled",
  ACTIVE: "active",
};

export const MEMBERSHIP_CANCEL_CONFIRMATION = [
  "too_expensive",
  "dont_use_anymore",
  "take_a_break",
  "other",
];

export const BUSINESS_MODEL = {
  PREPAID: "prepaid",
  MEMBERSHIP: "membership",
};

export const MEMBERSHIP_TYPE = {
  MONTHLY_PASS: "monthly_pass",
};

export const MEMBERSHIP_QUERY_KEY = "/memberships";

export const DEFERRED_PREPAYMENT = "deferred_prepayment";
export const DEFERRED_PREPAYMENT_STATUS = {
  PENDING: "pending",
  FAILED: "failed",
  SUCCEEDED: "succeeded",
};

export const SHOW_RECURRING_JOBS_MODAL_URL_PARAM = "show_recurring_modal";
